export class OrganizationRoutesConstants {
  public static readonly MY_ORGANIZATION = "my";
  public static readonly AI_USAGE = "ai-usage";
  public static readonly USERS = "users";
}
